import getConfig from 'next/config';
import file from './lottie/file.json';
import shakeHand from './lottie/shake hand.json';
import { HeroSectionConstants } from './types';
const { publicRuntimeConfig } = getConfig();

export const ITR_UTM_REF = 'itr_2025_organic_landing_page';
export const FILING_LINK = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing?utm_ref=${ITR_UTM_REF}`;
export const startFilingLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${ITR_UTM_REF}`;
export const startFilingLinkViewPlans = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${ITR_UTM_REF}`;
const rentalIncome = `https://cleartax.in/Entity?utm_ref=${ITR_UTM_REF}`;
const variantA = 'itr_landing_new_variant';
const variantB = 'itr_landing_new_variant_wp';
export const loginLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${variantA}`;
export const loginLinkViewPlans = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${variantB}`;

const COMPANY_METRICS = [
  {
    icon: file,
    title: '₹5,346 Cr+',
    desc: 'Life Time ITR Refund Delivered',
  },
  {
    icon: shakeHand,
    title: '8 M+',
    desc: 'users trust Cleartax',
  },
];

export const HERO_SECTION_CONSTANTS: HeroSectionConstants = {
  heading_h1: 'Income Tax e Filing',
  refundAmount: 418.26,
  platformText: 'We are now live for ITR filing on',
  platformLogos: [
    {
      src: 'https://assets.clear.in/cleartax/images/1751959705_image517.svg',
      alt: 'teams',
    },
    {
      src: 'https://cleartax-media.s3.amazonaws.com/cleartax/images/1755862072_waitrhp.webp',
      alt: 'whatsapp',
    },
    {
      src: 'https://assets.clear.in/cleartax/images/1751959858_image518.svg',
      alt: 'slack',
    },
  ],

  statistics: [
    {
      value: '★4.9/5',
      label: '45K+ Reviews ',
    },
    {
      value: '₹5,346 Cr+',
      label: 'Life Time ITR Refund Delivered',
    },
    {
      value: '8 M+',
      label: 'Users Trust Us',
    },
  ],

  subheading: {
    text: 'Seamless filing powered by AI',
    button: {
      text: 'File Now',
      url: 'https://cleartax.in/filing?utm_ref=itr_2025_organic_itr_homepage_hero_fold_cta',
    },
  },
};

const heroSection = {
  title: 'File ITR confidently for any <br/> type of income',
  lists: [
    'Zero data entry. Filing in under 3 minutes',
    'One-click broker import. 100+ broker supported',
    'Free notice management',
  ],
  AdvertisedProducts: [
    {
      productName: 'Belated Returns',
      productDescription:
        "Missed the deadline? File belated returns securely on our platform, guaranteeing 100% accuracy and ease for all filer's tax needs.",
      productImage:
        'https://assets.clear.in/cleartax/images/1694772997_group1814218576.png',
      productCTAText: 'Start filing',
      productCTALink: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/`,
      cardClasses: 'card1 py-9 my-5 sm:order-2',
      imgWidth: '45',
    },
    {
      productName: 'Tax Webinar',
      productDescription:
        'Join our webinar and unlock the secrets to saving money! Discover new and expert tax-saving strategies tailored to your unique income and investments with live Q&A.',
      productImage:
        'https://assets.clear.in/cleartax/images/1710409742_taxsavingwebinar.png',
      productCTAText: 'Register now for free',
      productCTALink: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/tax-webinar?utm_ref=ITR_homepage`,
      cardClasses: 'card2 py-14  sm:order-1',
      imgWidth: '60',
    },
    {
      productName: 'Notice Management',
      productDescription:
        'Notice management is crucial. Simplify tax notifications, minimize compliance risks, and maintain financial stability with our solution.',
      productImage:
        'https://assets.clear.in/cleartax/images/1694777357_group18142185621.png',
      productCTAText: 'Get help',
      productCTALink: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/services/tax-notice-management/p`,
      cardClasses: 'card3 py-9 my-5  sm:order-3',
      imgWidth: '45',
    },
  ],
  metrics: COMPANY_METRICS,
  buttons: [
    {
      text: 'Start Filing',
      url: startFilingLink,
    },
  ],
};

const itrSection = {
  title: 'Who can file Income Tax Returns (ITR) on Cleartax?',
  desc: "No matter what your source of income is, we've got you covered. There’s a plan for everybody!",
  cards: [
    {
      icon: 'https://assets.clear.in/cleartax/images/1695196425_salaried.png',
      className: 'hover:bg-[#EEF5FF]',
      title: 'Salaried',
      shortDesc: 'Single or multiple sources of income',
      fullDesc:
        'For taxpayers with salary income from a single/multiple sources. Upload Form16 or enter the details manually.',
      buttonText: 'Start now',
      buttonLink: startFilingLink,
    },
    {
      icon: 'https://assets.clear.in/cleartax/images/1695196494_group1814218585.png',
      className: 'hover:bg-[#FCF2F1]',
      title: 'Stocks, Crypto',
      shortDesc: 'Capital gains from Stocks, MFs, Crypto, F&O, etc.',
      fullDesc:
        'For taxpayers with Capital Gains from investments in Stocks, Mutual Funds, F&O, Crypto / VDA assets, etc.',
      buttonText: 'Start now',
      buttonLink: startFilingLink,
    },
    {
      icon: 'https://assets.clear.in/cleartax/images/1695196481_nri.png',
      className: 'hover:bg-[#FEF3E1]',
      title: 'Foreign Income',
      shortDesc: 'NRIs, RNORs, Foreign Income & Asset Holders',
      fullDesc:
        'For Individuals with Foreign Income or Foreign Assets, or NRI (Non-Resident-Indian) or RNOR (Resident-Not-Ordinarily-Resident)',
      buttonText: 'Start now',
      buttonLink: startFilingLink,
    },
    {
      icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685358690_business.png',
      className: 'hover:bg-[#FDF2ED]',
      title: 'Business',
      shortDesc: 'SMEs, MSMEs, Tally or other ERP users',
      fullDesc:
        'For SME/MSME businesses where books of accounts are maintained on Tally or other ERPs',
      buttonText: 'Start now',
      buttonLink: startFilingLink,
    },
    {
      icon: 'https://assets.clear.in/cleartax/images/1695196487_group1814218589huf.png',
      className: 'hover:bg-[#FDF2ED]',
      title: 'HUF',
      shortDesc: 'Filings for HUF (Hindu Undivided Family) ',
      fullDesc:
        'For HUF having income from house property, interest income, capital gains from shares & mutual funds, business income and others.',
      buttonText: 'Start now',
      buttonLink: rentalIncome,
    },
    {
      icon: 'https://assets.clear.in/cleartax/images/1695196433_selfemploye1.png',
      className: 'hover:bg-[#ECF7F4]',
      title: 'Self-Employed',
      shortDesc: 'Freelancers and other professionals',
      fullDesc:
        'For freelancers, doctors, lawyers, engineers, designers, photographers, consultants and other professionals',
      buttonText: 'Start now',
      buttonLink: startFilingLink,
    },
    {
      icon: 'https://assets.clear.in/cleartax/images/1695116687_group1814218584.png',
      className: 'hover:bg-[#EEF5FF]',
      title: 'Revised ITR',
      shortDesc: 'Revise your ITR in a few mins',
      fullDesc:
        'For tax filers who have already filed for FY 2024-25, but seek to edit and file a revised return',
      buttonText: 'Start now',
      buttonLink: startFilingLink,
    },
    {
      icon: 'https://assets.clear.in/cleartax/images/1695203710_selfemploye2.png',
      className: 'hover:bg-[#F3F3FD]',
      title: 'Belated ITR',
      shortDesc: 'Easy ITR filing after the deadline',
      fullDesc:
        'For taxpayers who missed the filing deadline of 15th September. Do easy filing of your Belated ITR',
      buttonText: 'Start now',
      buttonLink: startFilingLink,
    },
  ],
};

export const itrData = {
  heroSection,
  itrSection,
  isVariant: false,
  lastUpdatedDate: '2023-06-09T12:57:48+05:30',
};

export const REVIEW_CONSTANT = [
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685095581_maximumsaving.svg',
    title: 'Value for Money',
    desc: '70% customers told us',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685095625_5xfaster.svg',
    title: 'Fast Reconciliation',
    desc: '60% customers told us',
  },
  {
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1685095645_lessmanhours.svg',
    title: 'Time-saving',
    desc: '50% customers told us',
  },
];

export const ITR_FAQs = [
  {
    header: 'What is e Filing of income tax return (ITR)?',
    content: (
      <div>
        <p>
          Individuals, except senior citizens, have to mandatorily file the ITR
          through the online mode which is also known as electronic filing, i.e.
          e-filing of the income tax return.
        </p>
        <p>
          An income tax return is a form that a person is required to submit to
          the Income Tax Department. It contains information related to
          individual’s income and taxes paid, starting from 1st April to 31st
          March of the financial year. There are seven ITR forms prescribed by
          the Income Tax Department according to the amount of income, income
          source and the category to which the taxpayer belongs.
        </p>
        <p>
          E-filing of the income tax return can be done through Clear’s e-filing
          utility in a smooth and simple manner. Clear is a
          government-authorised portal to carry out e-filing of the returns and
          hence 100% authenticity and security is maintained.
        </p>
      </div>
    ),
  },
  {
    header: 'How can you file an income tax return in India?',
    content: (
      <p>
        You can file your income tax returns online, either on the income tax
        department’s website or with us at www.cleartax.in. Income Tax filing or
        e-filling is made easy on Cleartax. You can e-file your returns in just
        3 minutes without any manual effort. Also, note that the due date to
        e-file your income tax returns for the assessment year 2025-26 is on or
        before 15th September 2025.
      </p>
    ),
  },
  {
    header: 'My company deducts TDS. Do I still have to file my ITR?',
    content: (
      <p>
        Yes, deducting TDS and filing a tax return are two separate legal
        compliances. Income tax should be paid on your taxable income as per the
        provisions of the Income Tax Act. Whereas, you file a tax return to show
        that you’ve paid all the tax you needed to pay. The income tax return is
        also a very useful document when it comes to applying for a loan or
        visa.
      </p>
    ),
  },
  {
    header: 'Which income tax return should I select for e Filing?',
    content: (
      <p>
        There are seven forms - ITR 1, 2, 3, 4, 5, 6 and 7 notified by the
        government for different categories of taxpayers. ITR-1 to ITR-4 applies
        to individuals and HUFs. They can choose the appropriate ITR form based
        on the income earned and source of income. ITR-5 applies to partnership
        firms, LLPs, AOP (Association of Persons), BoI (Body of Individuals),
        Artificial Juridical Person (AJP), Estate of deceased, Estate of
        insolvent, Business trust and investment fund. All the companies should
        file ITR-6. It does not apply to companies claiming exemption from
        income from property held for charitable or religious purposes. Such
        companies should file ITR-7. If you are e-filing with ClearTax, we
        automatically decide on the correct income tax return form.
      </p>
    ),
  },
  {
    header: 'How do I pay tax to the government?',
    content: (
      <div className="font-medium text-base text-font-200">
        <div>
          You can pay tax to the government directly on the Income Tax
          Department website via e-Pay Tax using your net-banking account or
          debit card using challan 280. The payment types for below taxes are as
          follows-
        </div>

        <ol className="list-decimal pl-6">
          <li>
            <b>Advance Tax-</b> (100) Advance Tax
          </li>
          <li>
            <b>Self assessment tax-</b> (300) Self Assessment Tax
          </li>
          <li>
            <b>Regular assessment-</b> (400) Tax on Regular Assessment Tax
          </li>
        </ol>
      </div>
    ),
  },
  {
    header: `I am a salaried individual and don't have a Form 16. How can I file my tax return?`,
    content: (
      <p>
        You can still file your tax return on ClearTax without a Form 16. You’re
        just going to need your payslips and also check Form 26AS/AIS to ensure
        all the income reflected in 26AS/AIS is accurate and is reflected in
        your ITR. Follow the instructions on this{' '}
        <a href="https://cleartax.in/s/efile-without-form-16">guide</a> to
        e-file without Form 16.
      </p>
    ),
  },
  {
    header: 'What is ITR-V?',
    content: (
      <p>
        ITR-V is a 1-page document that you receive after e-filing your income
        tax return and where e-verification is pending. You can verify your
        income tax return through offline or online mode. There are various
        methods of online verification. However, to verify your return offline,
        you must print, sign and send the ITR-V to the Income Tax Department
        within 120 days from e-filing your tax return.
      </p>
    ),
  },
  {
    header:
      'Is it necessary to attach any documents along with the return of income?',
    content: (
      <p>
        ITR return forms are attachment-less forms and, hence, the taxpayer is
        not required to attach any document (like proof of investment, TDS
        certificates, etc.) along with the return of income (whether filed
        manually or filed electronically). However, these documents should be
        retained by the taxpayer and should be produced before the tax
        authorities when demanded in situations like assessment, inquiry, etc.
      </p>
    ),
  },
  {
    header: 'Can I file ITR-1 with exempt agricultural income?',
    content: (
      <p>
        You can file ITR 1 if the agricultural income is up to Rs 5,000. For
        agricultural income exceeding Rs 5,000, you have to file ITR 2. To know
        about ITR 2 .Click <a href="https://cleartax.in/s/itr2">here</a>.
      </p>
    ),
  },
  {
    header: 'If I have paid excess tax, how will it be refunded to me?',
    content: (
      <p>
        You can claim a refund of the excess tax paid by filing your Income-tax
        return. It will be refunded to you by crediting it to your bank account
        through ECS transfer. It is important to pre-validate your bank account
        details before filing your income tax return.
      </p>
    ),
  },
  {
    header:
      'Is it necessary to file a return of income when I don’t have any positive income?',
    content: (
      <div>
        <p>
          {' '}
          You must file your return before the due date, if you have sustained a
          loss in the financial year and if you want to carry forward it to the
          subsequent year for adjustment against the subsequent year’s income.
          Loss can be carried forward only if you have filed the return claiming
          such loss before the due date.(except in case of house property loss
          and unabsorbed depreciation)
        </p>
        <p>
          It is always advisable to file ITR even if the person is not
          mandatorily required to file the ITR according to the Income Tax Act.
          This is because the ITR return serves as a proof of income statement
          for various purposes like loan approval, VISA applications, credit
          card applications, claim income tax refunds and set off and carry
          forward of losses, etc.
        </p>
      </div>
    ),
  },
  {
    header: 'Who can file a tax return on ClearTax?',
    content: (
      <div className="font-medium text-base text-font-200">
        <div>
          Any person whose taxable income exceeds Rs. 10 can file their returns
          using cleartax, even when the tax liability is zero.
        </div>
      </div>
    ),
  },
  {
    header:
      'Is it mandatory for me to do the ITR e-filing or can someone else do it on my behalf?',
    content: (
      <p>
        You can seek the help of chartered accountants and agencies dedicated to
        ITR filing. It is wiser not to allow anyone to have your PAN and
        password in order to prevent any kind of fraud. Also, you can always
        take assistance from CA to file IT returns. With ClearTax you can get a
        Tax Expert to calculate your taxes and e-file your tax return. It is a
        totally safe and secured platform. See return filing plans
        <a href="https://cleartax.in/s/pricing"> here.</a>
      </p>
    ),
  },
  {
    header: 'Why should I e-file my income tax return?',
    content: (
      <div className="font-medium text-base text-font-200">
        <div>
          E-filing of income tax returns is mandatory if your income is above
          the basic exemption limit. ITR filing becomes a must even if your
          income is below the basic exemption limit if the below-mentioned
          conditions are met:
        </div>
        <ol className="list-decimal pl-6">
          <li>
            If you have deposited more than Rs1 crore in all of your current
            accounts
          </li>
          <li>
            If you have incurred expenditure on foreign travel of more than Rs 2
            lakh
          </li>
          <li>
            If you have incurred electricity expenditure of more than Rs 1 lakh
          </li>
          <li>
            If you have beneficial interests or signing authority in foreign
            countries
          </li>
          <li>If your total business turnover is above Rs 60 lakh</li>
          <li>If your gross professional receipts are above Rs 10 lakh</li>
          <li>
            If your total deposits in the savings bank account are Rs 50 lakh or
            more
          </li>
          <li>
            If the total of TDS and TCS is Rs 25,000 or more(Rs 50,000 or more
            in case of senior citizens)
          </li>
        </ol>
        It is always advisable to file ITR even if the person is not mandatorily
        required to file the ITR according to the Income Tax Act. This is
        because the ITR return serves as a proof of income statement for various
        purposes like loan approval, VISA applications, credit card
        applications, claim income tax refunds and set off and carry forward of
        losses, etc.
      </div>
    ),
  },
  {
    header: 'How to Check Income Tax e-Filing status?',
    content: (
      <div className="font-medium text-base text-font-200">
        To check your ITR e-filing status, follow the steps mentioned below:
        <b>Step 1:</b> Log on to the{' '}
        <a href="https://www.incometax.gov.in/iec/foportal">
          new income tax e-filing portal
        </a>{' '}
        by entering your PAN as user ID, and your login password. <br />
        <b> Step 2:</b> After logging in, Go to ‘e-File’ option in the top bar
        and select ‘Income Tax Returns’, and further select ‘View Filed Returns’
        from the drop-down. <br />
        Once you click on ‘View Filed Returns’, details of all the past returns
        filed by you will be displayed year-wise. You can also download the
        ITR-V acknowledgement through the ‘Download Receipts’ option, and your
        ‘ITR forms’ from there. You can click on the ‘View Details’ link to see
        the status of your ITR, including e-verification status and refund issue
        status if any.
      </div>
    ),
  },
  {
    header: 'What is the penalty for late Income tax e-Filing (ITR)?',
    content: (
      <div>
        <p>
          {' '}
          Income Tax Act levies penalties for late filing of income tax returns.
          Under Section 234F, a maximum late fee of Rs 5000 is applicable for
          filing ITR after due dates. <br />
          However, there is a relief given to small taxpayers, if the total
          income does not exceed Rs 5 lakh, the maximum penalty levied for delay
          will be Rs 1000.
        </p>
        <p>
          <b>Interest penalty on outstanding tax liability</b> <br />
          Under Section 234A of the Income Tax Act, a taxpayer with outstanding
          tax liability will have to pay monthly interest of 1% on the
          outstanding tax payable till the belated ITR is filed.
        </p>
      </div>
    ),
  },
  {
    header: 'Can I file my ITR myself?',
    content: (
      <p>
        Yes, ITR-1 and ITR 4 are simplified returns and can be easily filled
        with some basic knowledge. Also, if you are a salaried employee, then
        you can directly upload your Form 16 and all the details will get
        auto-populated in Clear’s (previously ClearTax) e-filing utility. This
        will make your ITR filing process very smooth and simplified. For more
        complex ITRs like ITR 2 or 3, it is better to gain some knowledge or go
        for expert advice.
      </p>
    ),
  },
  {
    header: 'What are the documents required for filing ITR?',
    content: (
      <div className="font-medium text-base text-font-200">
        <p>
          As you already know, PAN and Aadhaar are the most basic and essential
          documents to file an ITR.
        </p>
        <p>Let’s look at the other documents you need to file your ITR.</p>
        <ol className="list-decimal pl-6">
          <li>
            <b> Form 16: </b> Form 16 issued by your employer is also known as
            the Tax Deducted at Source (TDS) certificate. Your employer provides
            this form after furnishing the information related to the taxes paid
            on your behalf. In this form, you can view your salary, allowances,
            and deductions
          </li>
          <li>
            <b>Payslips: </b> It is essential to keep the salary slip ready for
            salaried taxpayers. Your salary slip consists of basic details such
            as your salary, House Rent Allowance (HRA), Dearness Allowance (DA),
            Traveling Allowances (TA), tax deducted, statutory deductions, etc.
            These details are essential to file income tax returns.
          </li>
          <li>
            <b>Form 26AS:</b> Form 26AS contains tax-related information such as
            TDS, advance tax, self-assessment tax, and TCS collected on your
            PAN. Apart from this, Form 26AS reflects details from Annual
            Information Return (AIR), which is filed by different entities, if
            you have invested or spent, mostly high-value transactions.
          </li>
          <li>
            <b>Annual Information Statement:</b> Annual information statement
            consist of comprehensive details of your financial information. It
            includes the transaction details even where TDS/TCS is not
            applicable. You can view your savings account interest details,
            mutual funds transactions, rental income, etc.
          </li>
          <li>
            <b>Form 16A/16B/16C:</b> Form 16A consists of whether you have any
            TDS on interest on fixed deposits, TDS on rental income, TDS on
            insurance commission, or any other income liable for a tax
            deduction. Form 16B provides details of TDS if you purchased a
            property during the previous year. Form 16C consists of TDS deducted
            on income from renting your plant and machinery
          </li>
          <li>
            <b> Interest certificates from banks or post offices:</b> Interest
            income from a savings bank account, fixed deposit, recurring deposit
            and post office savings accounts are taxable. Even if your bank does
            not deduct any TDS as you are well within the TDS limits, you should
            get the interest certificates to know the total interest earned. If
            you cannot get interest certificates, make sure your passbook is
            updated with details of interest income.
          </li>
          <li>
            <b> House property details:</b> If you live in a rental property,
            you’ve to collect the rental receipts and details of your house
            owner and PAN to claim HRA. If you are residing in your property,
            write down the property details, ownership %, etc. If you’ve taken a
            loan for the purchase/construction of the property, don’t forget to
            obtain the “loan repayment certificate” from your bank or NBFC. This
            certificate is essential in claiming interest paid under Section 24
            and principal repayment under Section 80C.
          </li>
          <li>
            <b>Capital gains details:</b> If you sell any property and earn
            profit from it, you must pay tax on that income. It is necessary to
            keep the sales deed in your hand if you have sold any property
            during the previous year. In case you have invested in shares,
            mutual funds, etc., and sold any during the previous year, you are
            required to collect a capital gain statement from your broking
            house. It contains the transaction-wise details of all the
            short-term capital gains and long-term capital gains.
          </li>
          <li>
            <b> Business PL and BS (with schedules):</b> Your business income
            which is to be reported in your ITR, has to be determined based on
            the profit and loss account and balance sheet. Hence, if you are
            doing a business, you should keep the PL and BS in hand to file ITR.
          </li>
          <li>
            Other income details: If you have any income, such as <br />
            a. Dividend income <br />
            b. Family pension <br />
            c. Interest from loans <br />
            d. Honorarium received <br />
            e. Tuition fee <br />
            f. Freelancer income <br />
            g. Winnings from the lottery, game shows, puzzles etc. <br />
            You should keep the related documents ready so that you don’t miss
            submitting these details while filing ITR.
          </li>
          <li>
            <b>Investment proofs: </b> You have to keep the documents related to
            the following documents to claim deductions under chapter VI-A of
            the Income Tax Act. These proofs include <br />
            a. Contribution to Employees Provident Fund (EPF) <br />
            b. Contribution to Public Provident Fund (PPF) <br />
            c. Investments in ELSS schemes <br />
            d. Life insurance premium payments <br />
            f. Contribution to National Pension System (NPS) <br />
            g. Children education expenses <br />
            h. Health insurance premium <br />
            i. Interest paid on the educational loan, etc. <br />
            Apart from the above deductions, if you are eligible for any
            deductions under sections 80D to 80U, you should keep those
            documents ready as well!
          </li>
        </ol>
      </div>
    ),
  },
  {
    header: 'What deductions can be claimed under the new tax regime?',
    content: (
      <p>
        While many tax saving deductions are not available under the new regime,
        taxpayers can still claim some of them. For example, employer&apos;s
        contribution to National Pension System (NPS under section 80CCD(2),
        interest paid on home loan of a let out property under section 24, and
        contribution to Agniveer Scheme under section 80CCH (only for defence
        personnels opting for agnipath scheme).
      </p>
    ),
  },
  {
    header:
      'I have not made tax planning in during the year. What deductions can I claim now while filing the return?',
    content: (
      <div>
        <p>
          {' '}
          It is advised to ascertain the income at the beginning of the
          financial year and start making tax saving investments accordingly.
          While this practice helps you to minimize your tax liability, you can
          always claim standard deduction on salary and rebate(when your income
          is up to specified limits) irrespective of you have made the expense
          or investment.
        </p>
        <p>
          While there are certain deductions applicable only in very niche
          cases, the above said deductions can be claimed by all resident
          individuals.
        </p>
      </div>
    ),
  },
  {
    header: 'When is the last date to file ITR for FY 2024-25(AY 2025-26)?',
    content: (
      <p>
        The last date for filing ITR for taxpayers not required to audit is
        extended to 15th September, 2025.
      </p>
    ),
  },
];
